import styles from "./styles.module.scss";
import reusedStyles from "../styles.module.scss";
import { motion, MotionValue, useScroll, useTransform } from "framer-motion";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { SiteContext } from "../../../../Contexts/SiteContext";
import { FeatureSection } from "./types";

// function useParallax(value: MotionValue<number>, distance: number) {
// 	return useTransform(value, [0, 1], [-distance, distance]);
// }
//
// function usePosition(value: MotionValue<number>) {
// 	return useTransform(value, [-1, 0], [0, 1]);
// }

const FeatureBlock = ({ section }: { section: FeatureSection }) => {
	const { deviceType } = useContext(SiteContext);

	// const { scrollYProgress }: { scrollYProgress: MotionValue<number> } = useScroll({
	// 	target: ref,
	// 	offset: ["start end", "end start"]
	// });


	// const y1 = useParallax(scrollYProgress, 150);
	// const y2 = useParallax(scrollYProgress, 250);
	// const opacity = useOpacity(scrollYProgress);

	return (
		<motion.div
			className="wrapper"
			initial={{ opacity: 0.5, backgroundSize: "" }}
			whileInView={{ opacity: 1 }}
			// style={{ y: position }}
			viewport={{
				amount: "some",
				margin: deviceType === "desktop" ? "-350px" : "-100px"
			}}
		>
			<div className="content">
				<h3>{section.heading}</h3>
				<div className="copy">{section.content}</div>
				<div className="img"><img src={section.image} alt={section.heading} width={300} /></div>
			</div>
		</motion.div>
	);
}

// function useClampedPosition(value: MotionValue<number>) {
// 	return useTransform(value, [0, 1], ["0%", "0%"]);
// }

function useOpacity(value: MotionValue<number>) {
	return useTransform(value, [0, 0.2, 0.7, 1], ["0%", "100%", "100%", "0%"]);
}

export default function Features({ title = "", background, data, logo = "" }: { title?: string, background: string, data: FeatureSection[], logo?: string }) {
	const ref = useRef(null);
	const [withinScrollWindow, setWithinScrollWindow] = useState(false);

	const { deviceType } = useContext(SiteContext);

	const { scrollYProgress }: { scrollYProgress: MotionValue<number>, scrollY: MotionValue<number> } = useScroll({
		target: ref,
		offset: ["start start", "end start"],
	});

	const onChange = useCallback((v) => {
		const isInViewport = v < 1 && v > 0;

		if (!withinScrollWindow && isInViewport) {
			setWithinScrollWindow(true);
		} else if (withinScrollWindow && !isInViewport) {
			setWithinScrollWindow(false);
		}
	}, [setWithinScrollWindow, withinScrollWindow]);

	useEffect(
		() => {
			scrollYProgress.onChange(onChange);
			// return () => {
			//		scrollYProgress.clearListeners(); 		
			// }
		},
		[onChange]
	);

	// const scrollYSmooth = useSpring(scrollYProgress, {
	// 	stiffness: 120,
	// 	damping: 60,
	// 	restDelta: 0.01
	// });

	const opacity = useOpacity(scrollYProgress);
	const isDesktop = deviceType === "desktop";

	return (
		<motion.div
			ref={ref}
			className={styles.section}
		>
			<motion.div
				// style={{ y: position }}
				style={{
					opacity: isDesktop ? opacity : 1,
					background: `url("${background}") center top no-repeat #fff`
				}}

				className={`${styles.fixedBottomLayer} ${deviceType === "desktop" && withinScrollWindow ? "fixed" : "inherit"}`}
			>
				{title && <h2 className={reusedStyles.heading}>{title}</h2>}
				{logo && <div className="logo">
					<img src={logo} width="200" alt="Honda Roadsync" />
				</div>}
			</motion.div>

			<div className="customContainer">
				<div className={styles.featuresContainer}>
					{data.map((section, s) => {
						return (
							<FeatureBlock key={s} section={section} />
						);
					})}
				</div>
			</div>
		</motion.div>
	);
}